import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export type FilterStateType = {
  selectedVegType: string; // "veg" or "non-veg"
  selectedCategoryType: string; // "new", "spicy", or "chef special"
  selectedMenuCategory: string; // Selected menu item (e.g., "Salads", "Meat")
  selectedTags: string[];
  selectedSizes: string[];
  selectedColors: string[];
  selectedRatings: number[];
  selectedAgeGroups: string[];
  selectedPlayTypes: string[];
  selectedCategories: string[];
};

const initialState: FilterStateType = {
  selectedVegType: "", // Empty string means "All" is selected by default
  selectedCategoryType: "",
  selectedMenuCategory: "",
  selectedTags: [],
  selectedSizes: [],
  selectedColors: [],
  selectedRatings: [],
  selectedPlayTypes: [],
  selectedAgeGroups: [],
  selectedCategories: [],
};

export const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setSelectedVegType: (state, action: PayloadAction<string>) => {
      state.selectedVegType = action.payload;
    },
    setSelectedCategoryType: (state, action: PayloadAction<string>) => {
      state.selectedCategoryType = action.payload;
    },
    setSelectedMenuCategory: (state, action: PayloadAction<string>) => {
      state.selectedMenuCategory = action.payload;
    },
    setSelectedTags: (state, action: PayloadAction<string[]>) => {
      state.selectedTags = action.payload;
    },
    setSelectedColors: (state, action: PayloadAction<string[]>) => {
      state.selectedColors = action.payload;
    },
    setSelectedSizes: (state, action: PayloadAction<string[]>) => {
      state.selectedSizes = action.payload;
    },
    setSelectedRatings: (state, action: PayloadAction<number[]>) => {
      state.selectedRatings = action.payload;
    },
    setSelectedCategories: (state, action: PayloadAction<string[]>) => {
      state.selectedCategories = action.payload;
    },
    setSelectedAgeGroups: (state, action: PayloadAction<string[]>) => {
      state.selectedAgeGroups = action.payload;
    },
    setSelectedPlayTypes: (state, action: PayloadAction<string[]>) => {
      state.selectedPlayTypes = action.payload;
    },
    resetFilters: (state) => {
      state.selectedVegType = initialState.selectedVegType;
      state.selectedCategoryType = initialState.selectedCategoryType;
      state.selectedMenuCategory = initialState.selectedMenuCategory;
      state.selectedTags = [];
      state.selectedSizes = [];
      state.selectedColors = [];
      state.selectedRatings = [];
      state.selectedPlayTypes = [];
      state.selectedAgeGroups = [];
      state.selectedCategories = [];
    },
  },
});

export const {
  resetFilters,
  setSelectedVegType,
  setSelectedCategoryType,
  setSelectedMenuCategory,
  setSelectedTags,
  setSelectedSizes,
  setSelectedColors,
  setSelectedRatings,
  setSelectedPlayTypes,
  setSelectedAgeGroups,
  setSelectedCategories,
} = filterSlice.actions;

export default filterSlice.reducer;
